import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface DeleteCustomerManagerParams {
    customerId: number;
    managerId: number;
}

export const useDeleteCustomerManager = (
    successCallback?: () => void,
): UseMutationResult<null, Error, DeleteCustomerManagerParams, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, DeleteCustomerManagerParams>({
        mutationFn: async ({ customerId, managerId }: DeleteCustomerManagerParams) => {
            const response = await axios.delete(
                enum_api_uri.delete_customer_manager
                    .replace(":customer_idx", customerId.toString())
                    .replace(":customer_manager_idx", managerId.toString()),
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getCustomerManager"] });
            queryClient.invalidateQueries({ queryKey: ["getCustomerList"] });

            successCallback?.();
        },
    });
};
